<template>

  <t-report-generate
      v-model="form"
      sub-validation-tag="sub-production-report-extract-by-step-order"
      default-excel
      enable-generate-excel
      landscape
      title="Relatório Extrato de Produção por Etapa Finalizada">

    <t-input-search v-model="form.dateRange" date date-monthly enable-range
                    label="Data Produzido"/>


    <t-input-search v-model="form.processFlowStepId" required :options="stepOptions"
                    label="Etapa" select/>

    <t-input-search v-model="form.operationStatusId"
                    :options="typeStatusProductionOptions"
                    label="Status Operacional"
                    select/>


    <t-input-code-label disable-name lot v-model="form.lotId"/>

    <b-row>

      <t-input-search v-model="form.groupProductId"
                      :options="groupProductOptions"
                      label="Grupo"
                      cols="6"
                      select/>

      <t-input-search label="Embalagem" placeholder="Todas" v-model="form.unitId"
                      cols="6"
                      :options="unitOptions" select/>

    </b-row>

    <slot name="status-order">

      <t-input v-model="form.optionStatusOrder" required checkbox
               :options="statusOrderOptions"
               label="Status Geral"/>

    </slot>


  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import ProcessFlowStepService from "@/services/modules/production/ProcessFlowStep.service";
import groupProductService from "@/services/modules/product/GroupProduct.service";
import unitService from "@/services/modules/product/Unit.service";
import TypeStatusProductionService from "@/services/modules/production/TypeStatusProduction.service";

export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportExtractProductionByStep',
  data() {
    return {
      path: "production/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        dateRange: "",
        processFlowStepId: 0,
        groupProductId: 0,
        unitId: 0,
        operationStatusId: 0,
        lotId: 0,
        optionStatusOrder: [4, 10, 91],
      },
      typeStatusProductionOptions: [],
      stepOptions: [],
      groupProductOptions: [],
      unitOptions: [],
    }
  },
  props: {
    statusOrderOptions: {
      type: [],
      default: [{value: 4, text: 'Em Andamento'}, {value: 10, text: 'Finalizado com sucesso'}, {
        value: 91,
        text: 'Finalizado com erro'
      }],
    },

  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await ProcessFlowStepService.selectList(0, true)
          .then(list => this.stepOptions = list)
          .catch(error => this.responseError(error))

      await groupProductService.selectList().then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))

      await unitService.selectList().then((response) => {
        this.unitOptions = response
      }).catch(error => this.responseError(error))

      await TypeStatusProductionService.selectList("")
          .then(list => this.typeStatusProductionOptions = list)
          .catch(error => this.responseError(error))

    },


  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
